// extracted by mini-css-extract-plugin
export var button = "Button-module--button--f49ff";
export var hollow = "Button-module--hollow--78e6a";
export var small = "Button-module--small--acc5c";
export var white = "Button-module--white--93ba6";